import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { routes, RouteProps } from '@lib/routes';

/** Tất cả config key đang được dùng trong routes */
export const MENU_ACCESS_KEYS: string[] = Array.from(
  new Set(
    routes
      .flatMap(r => [r, ...(r.children ?? [])])
      .map(r => r.UserAcceptsKey)
      .filter((k): k is string => !!k)
  )
);

export const selectRoutesFilter = createSelector(
  [
    (s: RootState) => s.user.routesFilter,
    (s: RootState) => s.user.account?.username,
    (s: RootState) => s.admin.menuUserAccess
  ],
  (routesFilter: string[] = [], username?: string, access: Record<string, string[]> = {}): string[] => {
    if (!username) return routesFilter;

    const canAccess = (r: RouteProps) =>
      !!r.UserAccepts?.includes(username) ||
      (!!r.UserAcceptsKey && (access[r.UserAcceptsKey] ?? []).includes(username));

    const filter = new Set(routesFilter);

    routes.forEach(group => {
      if (canAccess(group)) filter.delete(group.key);

      const children = group.children ?? [];
      const allowed = children.filter(canAccess);
      if (!allowed.length) return;

      // mở nhóm cha nhưng vẫn chặn các menu con khác
      if (filter.has(group.key)) {
        filter.delete(group.key);
        children.forEach(c => filter.add(c.key));
      }
      allowed.forEach(c => filter.delete(c.key));
    });

    return Array.from(filter);
  }
);
